<script lang="ts">
	import { get_all_grocery_lists } from "../tastummy";
	import type { GroceryList } from "./recipe.types";
	import { navigate } from "svelte-navigator";

	let list: GroceryList[] = [];
	get_all_grocery_lists().then((res) => {
		list = res.data;
	});
</script>

<div>
	{#each list as l (l.id)}
		<button on:click={() => navigate(`grocery-list/${l.id}`)}
			>{l.name}</button
		>
	{/each}
</div>

<style>
	button {
		margin: 1rem;
	}
</style>
